import LandingPage from "./components/LandingPage/LandingPage";

const Landing = LandingPage;

export default Landing;
